import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "account-menu",
  class: "dropdown-content"
}
const _hoisted_2 = { class: "nav-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  "data-target": "mobile-nav",
  class: "sidenav-trigger"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "menu")
], -1)
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  style: {"margin":"auto","max-width":"20%"},
  class: "hide-on-med-and-down"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  style: {"justify-content":"center","width":"50%"}
}
const _hoisted_7 = {
  action: "/search",
  method: "get"
}
const _hoisted_8 = {
  class: "hide-on-med-and-down",
  style: {"display":"flex"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"auto"} }, null, -1)
const _hoisted_10 = {
  id: "nav-mobile",
  class: "hide-on-med-and-down right",
  style: {"justify-content":"flex-end"}
}
const _hoisted_11 = {
  key: 0,
  id: "log-in-out",
  class: "tooltipped",
  "data-position": "bottom",
  "data-tooltip": "ログインしていません。クリックでログインできます。"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  onclick: "M.Modal.getInstance(document.getElementById('login-modal')).open()",
  class: "flex-center"
}, [
  /*#__PURE__*/_createTextVNode("ログイン"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "material-icons",
    style: {"color":"#0f0","margin-left":"10px"}
  }, "login")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  class: "sidenav",
  id: "mobile-nav",
  style: {"z-index":"1000"}
}
const _hoisted_15 = {
  key: 0,
  id: "log-in-out-mobile"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  onclick: "M.Modal.getInstance(document.getElementById('login-modal')).open()",
  class: "flex-center"
}, [
  /*#__PURE__*/_createTextVNode("ログイン"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "material-icons",
    style: {"color":"#0f0","margin-left":"10px"}
  }, "login")
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputTextField = _resolveComponent("InputTextField")!
  const _component_DropdownTrigger = _resolveComponent("DropdownTrigger")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _renderSlot(_ctx.$slots, "menu")
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          ($props.loggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("form", _hoisted_7, [
                  _createVNode(_component_InputTextField, {
                    label: "検索",
                    id: "search",
                    refForRef: "search",
                    name: "q",
                    "white-text": true,
                    "input-style": {'border-bottom': '1px solid #26a69a'},
                    "label-style": {top: '-5px'},
                    "default-value": $props.defaultSearchWord,
                    onInput: $options.fireInputEvent
                  }, null, 8, ["default-value", "onInput"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("ul", _hoisted_10, [
              (!$props.loggedIn)
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true),
              ($props.loggedIn)
                ? _renderSlot(_ctx.$slots, "common", { key: 1 })
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("li", null, [
                _createVNode(_component_DropdownTrigger, {
                  text: $props.username || 'SpicyAzisaBan',
                  target: "account-menu"
                }, null, 8, ["text"])
              ], 512), [
                [_vShow, $props.loggedIn]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_14, [
      (!$props.loggedIn)
        ? (_openBlock(), _createElementBlock("li", _hoisted_15, _hoisted_17))
        : _createCommentVNode("", true),
      ($props.loggedIn)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _renderSlot(_ctx.$slots, "common"),
            _renderSlot(_ctx.$slots, "menu")
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}